import { getMergedOptionGroupOptions } from 'shared-helpers/customAttributes';
import { TextWithLineBreaks } from 'components/common';
import { useReduxState } from 'hooks';

import type { UserCustomAttribute, UserCustomAttributes } from 'shared-types';

interface Props {
  attribute: UserCustomAttribute;
  value: UserCustomAttributes['key'];
}

const UserCustomAttributeDisplayValue = ({ attribute, value }: Props) => {
  const { language, messages } = useReduxState();

  const getValue = () => {
    if (attribute.type === 'ArrayWithOptions' && Array.isArray(value)) {
      const mergedOptions = getMergedOptionGroupOptions({
        language,
        optionGroups: attribute.optionGroups
      });
      return value
        .map((valueItem) => {
          const matchingOption = mergedOptions.find(
            (option) => option.key === valueItem
          );
          if (matchingOption) return matchingOption.label;
          return valueItem;
        })
        .join(', ');
    } else if (attribute.type === 'StringWithOptions') {
      const mergedOptions = getMergedOptionGroupOptions({
        language,
        optionGroups: attribute.optionGroups
      });
      const matchingOption = mergedOptions.find(
        (option) => option.key === value
      );
      if (matchingOption) return matchingOption.label;
    } else if (attribute.type === 'Array') {
      return Array.isArray(value) ? value.join(', ') : value || '';
    } else if (attribute.type === 'Boolean') {
      if (typeof value === 'boolean') {
        return value ? messages.commonYes : messages.commonNo;
      }
    } else if (attribute.type === 'Text') {
      return <TextWithLineBreaks text={(value as string) || ''} />;
    }

    return value || '';
  };

  return <div>{getValue()}</div>;
};

export default UserCustomAttributeDisplayValue;
